import React from 'react'

import { Dropdown } from '@fourthwall/components'

import { AnalyticsSelectTool } from '../AnalyticsSelectTool/AnalyticsSelectTool'
import type { PrecisionValue } from './AnalyticsPrecisionSelect.types'

type AnalyticsCompareDateRangeSelectProps = {
  value: PrecisionValue
  options: PrecisionValue[]
  onSelect: (value: PrecisionValue) => void
}

export const AnalyticsPrecisionSelect = ({
  value,
  options,
  onSelect,
}: AnalyticsCompareDateRangeSelectProps) => {
  const handleSelect = (option: PrecisionValue, close: () => void) => {
    onSelect(option)
    close()
  }

  return (
    <AnalyticsSelectTool
      label={`Group: ${value.label}`}
      disabled={options.length === 1}
      renderContent={({ close }) =>
        options.map((option) => (
          <Dropdown.Item
            active={value.value === option.value}
            key={option.value}
            label={option.label}
            onClick={() => handleSelect(option, close)}
          />
        ))
      }
    />
  )
}
